import { render, staticRenderFns } from "./BidAsk.vue?vue&type=template&id=590b1960"
import script from "./BidAsk.vue?vue&type=script&lang=js"
export * from "./BidAsk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports